import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import selectors from "selectors";
import { fetchPatientOrders } from "actions/orders";
import { Page } from "components/ui";
import { isEmpty } from "ramda";
import "./orders.scss";
import useTranslate from "hooks/use-translate-language";
import useDocumentTitle from "hooks/use-document-title";
import BreadCrumbs from "components/ui_new/breadcrumbs";
import OrderRow from "./order-row";
import OrderMobileCard from "./order-mobile-card";
import { useMediaQuery } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import { useKeyboardNavigation } from "./use-keyboard-navigation";

const Orders = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const orders = useSelector(selectors.getPatientOrders);
  const [isFetching, setIsFetching] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width: 900px)");

  // Set document title for accessibility
  useDocumentTitle(translate("requestedItems"));

  useKeyboardNavigation();

  useEffect(() => {
    setIsFetching(true);
    dispatch(fetchPatientOrders()).finally(() => setIsFetching(false));
  }, [dispatch]);

  return (
    <Page.Container>
      <Page.Header title={translate("myOrders")} goBack />
      <Page.Content
        isFetching={isFetching}
        isEmpty={isEmpty(orders)}
        emptyMessage={translate("noPreviousOrders")}
      >
        <div className="orders-page-content" id="orders">
          <div className="page-content-header">
            <BreadCrumbs
              childLabel="My Orders"
              parentLink="/orders"
              parentLinkLabel="Orders"
              title={translate("requestedItems")}
              titleClassname="orders-title"
            />
          </div>

          {!isSmallScreen ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="Orders Table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">
                      <span id="items-requested-header" className="table-header-title">
                        {translate("items")}
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      <span id="status-header" className="table-header-title">
                        {translate("status")}
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      <span id="details-header" className="sr-only">
                        {translate("viewDetailsButton")}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.map(order => (
                    <OrderRow key={order._id} order={order} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <div className="mobile-cards-container">
              {orders.map(order => (
                <OrderMobileCard key={order._id} order={order} />
              ))}
            </div>
          )}
        </div>
      </Page.Content>
    </Page.Container>
  );
};

export default Orders;
